import { useNavigation } from "@react-navigation/native";
import { useEffect } from "react";

export const useOnBeforeScreenRemove = (onBeforeScreenRemove: () => void) => {
    const navigation = useNavigation();

    useEffect(() => {
        navigation.addListener("beforeRemove", onBeforeScreenRemove);

        return () => {
            navigation.removeListener("beforeRemove", onBeforeScreenRemove);
        };
    }, [navigation, onBeforeScreenRemove]);
};
